import {
    useState,
    useMemo
} from 'react'
import { useDialogs } from '@shared/hooks/dialogs'

export const useEstimationPreview = (instance) => {
    const { close } = useDialogs()
    const [tab, setTab] = useState('data')
    const handleClose = () => close('previewEstimation')
    // lightbox
    const [lightbox, setLightbox] = useState({ open: false, group: null, index: 0 })

    const documentsImages = useMemo(
        () => instance.images.filter(i => i.dep == 'documents'),
        [instance.images]
    )
    const locationImages = useMemo(
        () => instance.images.filter(i => i.dep == 'location'),
        [instance.images]
    )
    const violationsImages = useMemo(
        () => instance.images.filter(i => i.dep == 'violations'),
        [instance.images]
    )

    const groupsMap = {
        documents: documentsImages,
        location: locationImages,
        violations: violationsImages,
    }

    const currentSlides = lightbox.group
        ? groupsMap[lightbox.group].map(img => ({ src: img.url || img.image }))
        : []

    const openLightbox = (group) => (index) => setLightbox({ open: true, group, index })
    const closeLightbox = () => setLightbox(prev => ({ ...prev, open: false }))

    return {
        tab,
        setTab,

        handleClose,
        documentsImages,
        locationImages,
        violationsImages,
        lightbox,
        currentSlides,
        openLightbox,
        closeLightbox
    }
}
